import React from "react";
import equiomIcon from "../../assets/EquiomIconSquare.png";
import equiomIconGrey from "../../assets/EquiomIconSquareGrey.png";

interface Props {
    error?: boolean;
}

export const AnswerIcon: React.FC<Props> = ({ error }) => {
    return <img src={error ? equiomIconGrey : equiomIcon} alt="Equiom Icon" />;
};
